import { render, staticRenderFns } from "./ExperienceItem.vue?vue&type=template&id=bf702ff0&scoped=true&"
import script from "./ExperienceItem.vue?vue&type=script&lang=js&"
export * from "./ExperienceItem.vue?vue&type=script&lang=js&"
import style0 from "./ExperienceItem.vue?vue&type=style&index=0&id=bf702ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf702ff0",
  null
  
)

component.options.__file = "ExperienceItem.vue"
export default component.exports